/**
 * Single source of truth for the backend base URL.
 * Override per environment with REACT_APP_API_URL in crm/.env
 * (e.g. REACT_APP_API_URL=https://api.example.com).
 */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
